import PropTypes from "prop-types";
import React from "react";

export function ProudToServeLogo({ companyName, fileName, link }) {
	return (
		<li>
			<a
				href={link}
				aria-label={`External link to the ${companyName} website`}
				target="_blank"
				rel="noopener noreferrer"
			>
				<img
					src={`/static/img/logos/${fileName}`}
					alt={`Logo ${companyName}`}
				/>
			</a>
		</li>
	);
}

ProudToServeLogo.propTypes = {
	companyName: PropTypes.string.isRequired,
	fileName: PropTypes.string.isRequired,
	link: PropTypes.string.isRequired,
};
